import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetLicenseKeyDashboardResponse } from '../type/types';

/** 라이선스 키 대시보드 정보 조회 */
export const getLicenseKeyDashboard = async () => {
  const res = await api.get<ApiResponseType<GetLicenseKeyDashboardResponse>>(
    `/api/web/admins/license-keys/dashboard`
  );
  return res.data;
};
